import { useTranslation } from 'react-i18next';
import React from 'react';
import CommonButton from '@src/new-components/Button';
import { Typography } from '@mui/material';
import MicRoundedIcon from '@mui/icons-material/MicRounded';
import { COLOR } from '@src/styles/color';
import { StyledRecordAgain } from './index.style';

const RecordAgain = ({
  audioError,
  handleReset,
  handleRequestMic,
  isMicPermissionDenied,
}) => {
  const { t } = useTranslation();

  return (
    <StyledRecordAgain>
      {audioError && (
        <Typography variant="body1" color={COLOR.errorDropZone}>
          {audioError}
        </Typography>
      )}
      <CommonButton
        startIcon={!isMicPermissionDenied && <MicRoundedIcon />}
        variant="contained"
        textProps={{
          variantText: 'body-14-bold',
          color: COLOR.darkBlue,
        }}
        customStyle={{
          width: 'max-content',
          margin: '0 auto',
        }}
        onClick={isMicPermissionDenied ? handleRequestMic : handleReset}
      >
        {isMicPermissionDenied ? t('tryAgain') : t('recordAgain')}
      </CommonButton>
    </StyledRecordAgain>
  );
};

export default RecordAgain;
